import { AdminUsersManagement } from "@/components/AdminUsersManagement";
import { useLanguage } from "@/contexts/LanguageContext";

const Admin = () => {
  const { t } = useLanguage();

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">{t("admin.title")}</h1>
      <AdminUsersManagement />
    </div>
  );
};

export default Admin;
